/** @jsxImportSource @emotion/react */
import { Button } from 'react-bootstrap'
import moment from 'moment'

import { PreAuthorizationForm } from '../payor/PreAuthorizationForm'
import { Order, FollowUpNamespace } from 'store/types'
import { useSetCopayAmountMutation, useSetLabOrderPayerInfoMutation } from 'store/services/labOrder'
import { Notes } from './Notes';

interface IProps {
  order: Order
}

export const PreAuthorization = ({ order }: IProps) => {
  const [setOrderPayerInfo] = useSetLabOrderPayerInfoMutation()
  const [setCopayAmount] = useSetCopayAmountMutation()

  const followUps = order?.followUpsList
    ?.filter((f) => f.namespace === FollowUpNamespace.HST_PRE_AUTHORIZATION)
    ?.sort((a, b) => moment(b.addedAt).diff(moment(a.addedAt)))

  const onSubmit = async (values: any) => {
    await Promise.all([
      setOrderPayerInfo({
        orderId: order?.id,
        followUpDate: values.followUpDate ? moment(values.followUpDate).format('YYYY-MM-DD') : '',
        notes: values.notes,
        authorizationNumber: values.authorizationNumber,
        maxUnitsBilledOut: values.maxUnitsBilledOut ? Number(values.maxUnitsBilledOut) : undefined,
        authorizationState: values.authorizationState,
        authorizationValidStartDate: values.authorizationValidStartDate,
        authorizationValidEndDate: values.authorizationValidEndDate,
      }).unwrap(),
      setCopayAmount({
        orderId: Number(order?.id),
        value: values.copayAmount,
      }).unwrap(),
    ])
  }

  return (
    <div className="w-100">
      <div className="row">
        <div className="col-sm-10 p-0 d-flex align-items-center">
          <h4 className="m-0">Pre Authorization</h4>
        </div>
      </div>
      <div className="row">
        <div
          className="col-xl-6 col-lg-12 p-3 mt-3 d-flex flex-column align-items-end"
          css={{ background: '#F5F5F5' }}>
          <PreAuthorizationForm order={order} onSubmit={onSubmit} />
          <div className="d-flex">
            <Button variant="primary" className="mt-2" type="submit" form="insuranceInfo">
              Save Changes
            </Button>
          </div>
        </div>
        <div className="col-xl-6 col-lg-12 p-3 mt-3">
          <Notes
            followUps={followUps}
            orderId={Number(order.id)}
            isAutoSmsAvailable={false}
          />
        </div>
      </div>
    </div>
  )
}
